<template>
  <div>
    <!-- หน้ารอโหลด -->
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <!-- ค้นหาเลขซ่อม -->
      <div class="search-filters">
        <b-form-group :label="$t('searchorder')">
          <b-form-input
            v-model="search.order"
            :placeholder="$t('placeholderOrderFix')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchUser')">
          <b-form-input
            v-model="search.username"
            :placeholder="$t('user')"
          />
        </b-form-group>
		
		 <b-form-group :label="$t('searchsn')">
          <b-form-input
            v-model="search.sn"
            :placeholder="$t('sn')"
          />
        </b-form-group>

        <b-form-group :label="$t('searchcate')">
          <b-form-select
            v-if="categories.length > 0"
            v-model="categoryId"
            :options="categories"
            required
            :select-size="2"
            class="input-box"
          />
          <div v-else>
            {{ $t('loading') }}
          </div>
        </b-form-group>

        <!--  รอเเก้บัคหลังบ้าน
        <b-form-group label="เลือกวันเริ่มต้น">
          <b-form-input
            v-model="search.startDate"
            type="date"
          />
        </b-form-group>

        <b-form-group label="เลือกวันสิ้นสุด">
          <b-form-input
            v-model="search.endDate"
            type="date"
          />
        </b-form-group>-->

        <b-button
          style="margin-top: 12px; background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          @click="searchFixes(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>

        <b-button
          style="margin-top: 12px; height: 40px; background-color: gray; color: white; border: none;"
          variant="text-warning"
          @click="clearSearch"
        >
          {{ $t('reset') }}
        </b-button>

      </div>

      <!-- ปุ่มแสดงสถานะ -->
      <div class="btn-space">
        <b-button
          :variant="activePageButton === 'normalStatus' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(1, 'normalStatus')"
        >
          {{ $t('allfixjob') }}
        </b-button>
        <b-button
          :variant="activePageButton === 'workerTasks' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(2, 'workerTasks')"
        >
          {{ $t('showfixjob') }}
        </b-button>
        <b-button
          :variant="activePageButton === 'waitingApprove' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="headApprovelButtonClick(0, 'waitingApprove')"
        >
          {{ $t('headcheck') }}
        </b-button>
        <b-button
          :variant="activePageButton === 'specialStatus' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(3, 'specialStatus')"
        >
          {{ $t('cancelSucc') }}
        </b-button>
      </div>

      <!-- ตารางซ่อม -->
      <div class="table-wrapper">
        <b-table
          v-if="!isLoading && totalFixes > 0"
          :items="fixes"
          :fields="fields"
          class="fix-table"
        >
          <template #cell(order)="data">
            {{ data.item.order || '' }}
          </template>
          <template #cell(timefix)="data">
            {{ new Date(data.item.timefix).toLocaleString('th-TH', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            }) || '' }}
          </template>
          <template #cell(category)="data">
            {{ data.item.category.nameCate || '' }}
          </template>
          <template #cell(subcategory)="data">
            {{ data.item.subcategory.name || '' }}
          </template>
          <template #cell(location)="data">
            {{ data.item.location ? data.item.location.locationName : '' }}
          </template>

          <template #cell(user)="data">
            <b-button
              variant="link"
              @click="showEmployeeModal(data.item.user.id)"
            >
              {{ data.item.user.username || '' }}
            </b-button>
          </template>

          <template #cell(devicecategory)="data">
            {{ data.item.deviceCategory ? data.item.deviceCategory.name : '' }}
          </template>
          <template #cell(devicesubcategory)="data">
            <span>{{ data.item.deviceSubcategory ? data.item.deviceSubcategory.name : '' }}</span>
          </template>
          <template #cell(fixDetails)="data">
            <span>
              {{ data.item.fixDetails && Array.isArray(data.item.fixDetails) ? data.item.fixDetails.map(detail => detail.detail ? detail.detail.substring(0, 5) + (detail.detail.length > 5 ? '...' : '') : '').join(', ') : '' }}
            </span>
          </template>
          <template #cell(fixDetailsAdditional)="data">
            <span>
              {{ data.item.fixDetailsAdditional && Array.isArray(data.item.fixDetailsAdditional) ? data.item.fixDetailsAdditional.map(addDetail => addDetail.fixdetail ? addDetail.fixdetail.substring(0, 5) + (addDetail.fixdetail.length > 5 ? '...' : '') : '').join(', ') : '' }}
            </span>
          </template>
          <template #cell(operator)="data">
            {{ data.item.operator ? data.item.operator.substring(0, 5) + (data.item.operator.length > 5 ? '...' : '') : '' }}
          </template>

          <template #cell(status)="data">
            {{ data.item.status ? data.item.status.statusName : '' }}
          </template>
          <template #cell(actions)="data">
            <b-button
              class="b-btn"
              variant="primary"
              size="sm"
              @click="viewDetails(data.item)"
            >
              {{ $t('details') }}
            </b-button>

            <template v-if="data.item && data.item.status && ![1, 4, 5].includes(data.item.status.id)">
              <b-button
                class="b-btn"
                variant="warning"
                size="sm"
                @click="editFix(data.item)"
              >
                {{ $t('edit') }}
              </b-button>
            </template>
            <template v-if="data.item.status.id === 1">
              <b-button
                class="b-btn"
                variant="success"
                size="sm"
                @click="confirmModel(data.item)"
              >
                {{ $t('getjob') }}
              </b-button>
            </template>
          </template>
        </b-table>

        <div
          v-if="!isLoading && totalFixes === 0"
          class="text-center mt-3"
        >
          <p style="font-size: 28px; font-weight: bold;">
            {{ $t('nofix') }}
          </p>
        </div>
      </div>

      <!-- Default -->
      <div
        v-if="!isLoading && !isSearchActive && !isWaitingApprove && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'normal'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChange"
        />
      </div>

      <!-- Search -->
      <div
        v-if="!isLoading && isSearchActive && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'search'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChangesearch"
        />
      </div>

      <!-- Waiting Approve -->
      <div
        v-if="!isLoading && isWaitingApprove && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'waiting'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChangewaitingApprove"
        />
      </div>

      <!-- model ซ่อม -->
      <b-modal
        v-model="showForm"
        :title="$t('fixedit')"
        class="custom-modal"
        size="xl"
        hide-footer
        @hidden="clearSelectedFix"
      >
        <UpdateForm
          :fix="selectedFix"
          :categories="categories"
          :devices="Object.values(devices)"
          :users="users"
          :locations="locations"
          @fix-saved="handleFixSaved"
          @close="showForm = false"
        />
      </b-modal>

      <!--model user-->
      <EmployeeModal
        :show="modalShowfix"
        :employee="selectedEmployee"
        @close="modalShowfix = false"
      />

      <!--model device-->
      <div
        v-if="isLoadingDeviceDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>
      <DeviceModel
        :local-show-modal="localShowModal"
        :warranty="warrantyData"
        :hardware="deviceHardwareList"
        :fixhistory="fixhistoryList"
        :expensefix="expensefixList"
        :devicehistory="devicehistoryList"
        :spare="SpareList"
        :pmhistory="pmhistoryList"
        :details="selectedDevice || {}"
        @close="handleCloseModal"
      />

      <!-- model รายละเอียด -->
      <div
        v-if="isLoadingViewDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>
      <DetailsModal
        v-if="!isLoadingViewDetails"
        :show="showDetailsModal"
        :expense="expense"
        :spare-list="spareList"
        :fix="selectedFix"
        @close="showDetailsModal = false"
      />
    </div>
    <!--model confirm-->
    <b-modal
      v-model="showConfirmationModal"
      :title="$t('confirmfixer')"
      :ok-title="$t('yes')"
      :cancel-title="$t('cancel')"
      @ok="confirm"
    >
      <p class="my-4">
        {{ $t('confirmdetails') }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import { getRolesFromToken } from '@/services/JwtDecoder'
import apiAdmin from '@/services/admin'
import apiSetting from '@/services/Setting'
import apiMst from '@/services/masterDate'
import apiAuth from '@/services/auth'
import apiUpdate from '@/services/update'
import UpdateForm from './UpdateForm.vue'
import DetailsModal from '../AdminReviwer/DetailsModal.vue'
import EmployeeModal from '../AdminReviwer/EmployeeModel_fix.vue'
import DeviceModel from '../MasterData/DeviceModel.vue'

export default {
  components: {
    UpdateForm,
    DetailsModal,
    EmployeeModal,
    DeviceModel,
  },
  data() {
    return {
      fixes: [],
      categories: [],
      categoryId: null,
      users: [],
      devices: [],
      categoryName: '',
      search: {
        order: '',
        username: '',
        startDate: '',
        endDate: '',
        categoryName: '',
		sn: '',
      },
      roles: [],
      isLoading: true,
      isButtonEnabled: true,
      debounceTimeout: null,
      showForm: false,
      showDetailsModal: false,
      selectedFix: null,
      errorMessage: '',
      showAllStatus: false,
      filterMode: 'normal',
      activePageButton: 'normalStatus',
      spareList: [],
      expense: {},
      workerId: { id: this.getCurrentUserId() },
      modalShowfix: false,
      modalShowdevice: false,
      selectedEmployee: {},
      localShowModal: false,
      selectedDevice: {},
      warrantyData: [],
      deviceHardwareList: [],
      pmhistoryList: [],
      currentPage: 1,
      itemsPerPage: 5,
      totalItems: 0,
      sortKey: 'timefix',
      sortOrder: 'desc',
      totalFixes: 0,
      selectedStatusId: 1,
      isLoadingViewDetails: false,
      isLoadingDeviceDetails: false,
      fixhistoryList: [],
      expensefixList: [],
      devicehistoryList: [],
      SpareList: [],
      isSearchActive: false,
      showConfirmationModal: false,
      confirmModelItem: null,
      locations: [],
      isWaitingApprove: false,
    }
  },

  computed: {
    currentStatusId() {
      console.log('Current statusId from Vuex:', this.$store.state.statusId)
      return this.$store.state.statusId // เข้าถึง statusId จาก store
    },
    fields() {
      return [
        { key: 'order', label: this.$t('placeholderOrderFix'), sortable: true },
        { key: 'timefix', label: this.$t('fixDate'), sortable: true },
        { key: 'category', label: this.$t('cate'), sortable: true },
        { key: 'subcategory', label: this.$t('subcate'), sortable: true },
        { key: 'location', label: this.$t('locationname'), sortable: true },
		{
          key: 'sn', label: this.$t('sn'), sortable: true, thClass: 'text-center',
        },
        { key: 'user', label: this.$t('user'), sortable: true },
        { key: 'fixDetails', label: this.$t('fixDetails'), sortable: true },
        { key: 'fixDetailsAdditional', label: this.$t('problem'), sortable: true },
        { key: 'operator', label: this.$t('operator'), sortable: true },
        { key: 'status', label: this.$t('status'), sortable: true },
        { key: 'actions', label: this.$t('management') },
      ]
    },
  },

  watch: {
    categoryId(newValue) {
      this.updateCategoryName(newValue)
    },
  },

  async mounted() {
    this.accessToken = localStorage.getItem('accessToken')
    this.roles = getRolesFromToken(this.accessToken)
    await this.loadData()
  },
  created() {
    this.fetchUsers()
  },

  methods: {
    async loadData() {
      await Promise.all([this.fetchFixes(), this.fetchCategories(), this.fetchLocations()])
    },

    updateCategoryName(newValue) {
      const categoryId = Number(newValue)
      const category = this.categories.find(item => item.value === categoryId)
      if (category) {
        this.categoryName = category.text
        this.search.categoryName = category.text
      } else {
        this.categoryName = ''
        this.search.categoryName = ''
      }
    },

    async searchFixes(page = 1) {
      this.isLoading = true
      this.isWaitingApprove = false
      try {
        if (!this.search.order && !this.search.username && !this.search.startDate && !this.search.endDate && !this.search.categoryName && !this.search.sn) {
          if (this.fixes.length === 0 || page === 1) {
            this.isSearchActive = false
            this.selectedStatusId = 1
            this.activePageButton = this.getButtonType(1)
            this.currentPage = 1
            await this.fetchFixes(1)
            return
          }
        }
        this.isSearchActive = true
        this.currentPage = page

        const params = {
          order: this.search.order,
          username: this.search.username,
          startDate: this.search.startDate,
          endDate: this.search.endDate,
		  sn: this.search.sn || null,
          page: page - 1,
          size: this.itemsPerPage,
        }

        if (this.search.categoryName) {
          params.categoryName = this.search.categoryName
        }
		
		if (this.search.sn) {
          params.sn = this.search.sn
        }

        let response

        if (this.roles.includes('WORKER')) {
          response = await apiAdmin.get(`/fixgetworkerId/search/${this.workerId.id}`, { params })
        } else {
          response = await apiAdmin.get(`/fixgetuserId/search/${this.$store.getters.userId}`, { params })
        }

        this.fixes = await Promise.all(response.data.content.map(async fix => {
          const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
          const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
          const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
          return {
            ...fix,
            fixDetails: detailsResponse.data || [],
            fixDetailsAdditional: additionalResponse.data || [],
            fixsolution: solutionResponse.data || [],
          }
        }))
        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        // หากค้นหาแล้วไม่มีข้อมูล
        if (this.totalFixes === 0) {
          this.errorMessage = 'ไม่พบข้อมูลที่ค้นหา'
          this.currentPage = 1
          page = 1
        } else {
          this.errorMessage = ''
        }

        this.activePageButton = null
      } catch (error) {
        console.error('Error fetching fixes:', error)
        this.fixes = []
        this.totalFixes = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
        this.localShowModal = false
      }
    },

    confirmModel(item) {
      if (item && item.id) {
        this.confirmModelItem = item
        this.showConfirmationModal = true
      } else {
        this.errorMessage = 'ข้อมูลไม่ถูกต้อง'
        console.error('ข้อมูลที่ได้รับไม่ถูกต้อง', item)
      }
    },

    async fetchFixes() {
      this.isLoading = true
      this.errorMessage = ''

      try {
        const params = {
          statusId: this.selectedStatusId,
          page: this.currentPage - 1,
          size: this.itemsPerPage,
        }

        let response

        // Check user roles to fetch the correct data
        if (this.roles && Array.isArray(this.roles)) {
          if (this.roles.includes('ADMIN')) {
            response = await apiAdmin.get('/fix', { params })
          } else {
            // Check if statusId is 1
            if (this.selectedStatusId === 1) {
              response = await apiAdmin.get('/fixworkerAll', { params })
            } else {
              // Use /fixgetworkerId for other statuses
              response = await apiAdmin.get(`/fixgetworkerId/${this.workerId.id}`, { params })
            }
          }
        } else {
          throw new Error('Roles are not defined or not an array.')
        }

        // Check response status and data
        if (response.status === 200 && Array.isArray(response.data.content)) {
          this.fixes = response.data.content
          this.totalFixes = response.data.totalElements || 0 // Ensure this is set correctly
          this.totalPages = response.data.totalPages || 0

          this.fixes = await Promise.all(this.fixes.map(async fix => {
            try {
              const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
              const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
              const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
              return {
                ...fix,
                fixDetails: detailsResponse.data || [],
                fixDetailsAdditional: additionalResponse.data || [],
                fixsolution: solutionResponse.data || [],
              }
            } catch (error) {
              console.error(`Error fetching details for fix ${fix.id}:`, error)
              return {
                ...fix, fixDetails: [], fixDetailsAdditional: [], fixsolution: [],
              }
            }
          }))

          // อัปเดตข้อมูลจำนวนทั้งหมดและจำนวนหน้า
          this.totalFixes = response.data.totalElements
          this.totalPages = response.data.totalPages
        } else {
          this.fixes = []
          this.totalFixes = 0
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.fixes = []
          this.totalFixes = 0
        } else {
          this.errorMessage = 'ไม่สามารถโหลดข้อมูลการซ่อมได้'
          console.error('Error fetching fixes:', error)
        }
      } finally {
        this.isLoading = false
        this.localShowModal = false
        this.showDetailsModal = false
      }
    },

    async fetchFixesheadApprove() {
      this.isLoading = true
      this.errorMessage = ''
      this.isWaitingApprove = true

      try {
        const params = {
          page: this.currentPage - 1,
          size: this.itemsPerPage,
        }

        const response = await apiAdmin.get(`/fixworkerHead/${this.$store.getters.userId}`, { params })

        if (response.status === 200 && Array.isArray(response.data.content)) {
          this.fixes = response.data.content
          this.totalFixes = response.data.totalElements || 0
          this.totalPages = response.data.totalPages || 0

          this.fixes = await Promise.all(this.fixes.map(async fix => {
            try {
              const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
              const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
              const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
              return {
                ...fix,
                fixDetails: detailsResponse.data || [],
                fixDetailsAdditional: additionalResponse.data || [],
                fixsolution: solutionResponse.data || [],
              }
            } catch (error) {
              console.error(`Error fetching details for fix ${fix.id}:`, error)
              return {
                ...fix, fixDetails: [], fixDetailsAdditional: [], fixsolution: [],
              }
            }
          }))

          this.totalFixes = response.data.totalElements
          this.totalPages = response.data.totalPages
        } else {
          this.fixes = []
          this.totalFixes = 0
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.fixes = []
          this.totalFixes = 0
        } else {
          this.errorMessage = 'ไม่สามารถโหลดข้อมูลการซ่อมได้'
          console.error('Error fetching fixes:', error)
        }
      } finally {
        this.isLoading = false
        this.localShowModal = false
        this.showDetailsModal = false
      }
    },

    async handlePageChange(page) {
      this.localShowModal = false
      this.currentPage = page
      await this.fetchFixes(this.currentPage)
    },

    async handlePageChangesearch(page) {
      this.localShowModal = false
      this.currentPage = page
      await this.searchFixes(this.currentPage)
    },

    getButtonType(statusId) {
      switch (statusId) {
        case 1: return 'normalStatus'
        case 2: return 'workerTasks'
        case 3: return 'specialStatus'
        default: return null
      }
    },

    onSortChange({ key, order }) {
      this.sortKey = key // กำหนดฟิลด์ที่ต้องการเรียงลำดับ
      this.sortOrder = order // กำหนดลำดับการเรียง
    },

    async showEmployeeModal(userId) {
      try {
        const response = await apiAuth.get(`auth/showbyid/${userId}`)
        console.log(response)
        this.selectedEmployee = response.data
        this.modalShowfix = true
      } catch (error) {
        console.error('Error fetching employee data:', error)
      }
    },

    async showDeviceModal(deviceId) {
      console.log('Device ID sent to API:', deviceId)

      this.isLoadingDeviceDetails = true

      try {
        const [response, hardwareResponse, warrantyResponse, fixhistoryRes, expenseHisRes, deviceHistoryRes, spareListRes, pmhistoryRes] = await Promise.allSettled([
          apiMst.get(`/deviceListId/${deviceId}`),
          apiMst.get(`/devicehardwareByDeviceId/${deviceId}`),
          apiMst.get(`/warrantyByDeviceId/${deviceId}`),
          apiAdmin.get(`/fixgetdevice/${deviceId}`),
          apiAdmin.get(`/expensefixList/device/${deviceId}`),
          apiAdmin.get(`/deviceUseHistoryGet/${deviceId}`),
          apiAdmin.get(`/sparelistByDevice/${deviceId}`),
          apiAuth.get(`/calendar/getdeviceCalendar?deviceId=${deviceId}`),
        ])

        // ดึงข้อมูลจากผลลัพธ์
        this.selectedDevice = response.status === 'fulfilled' ? response.value.data : {}
        this.deviceHardwareList = hardwareResponse.status === 'fulfilled' ? hardwareResponse.value.data || [] : []
        this.warrantyData = warrantyResponse.status === 'fulfilled' ? warrantyResponse.value.data || [] : []
        this.fixhistoryList = fixhistoryRes.status === 'fulfilled' ? fixhistoryRes.value.data || [] : []
        this.expensefixList = expenseHisRes.status === 'fulfilled' ? expenseHisRes.value.data || [] : []
        this.devicehistoryList = deviceHistoryRes.status === 'fulfilled' ? deviceHistoryRes.value.data || [] : []
        this.pmhistoryList = pmhistoryRes.status === 'fulfilled' ? pmhistoryRes.value.data || [] : []

        if (spareListRes.status === 'fulfilled') {
          const spareData = Array.isArray(spareListRes.value.data) ? spareListRes.value.data : []
          this.SpareList = spareData.map((spare, index) => ({
            id: spare.id,
            orderlist: index + 1,
            list: spare.spList || '',
            purchase: spare.spPurchase || '',
            quantity: spare.spQuantity || '',
            cost: spare.spCost || 0,
            source: spare.spSource || '',
            detail: spare.spDetail || '',
          }))
        } else {
          this.SpareList = []
        }

        this.$nextTick(() => {
          this.localShowModal = true
        })
      } catch (error) {
        console.error('Error fetching device details:', error)
      } finally {
        this.isLoadingDeviceDetails = false
      }
    },

    async fetchCategories() {
      try {
        const response = await apiSetting.get('/cate')
        if (response.data && Array.isArray(response.data)) {
          this.categories = response.data.map(item => ({
            value: item.id,
            text: item.nameCate,
          }))
        } else {
          this.categories = []
        }
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดหมวดหมู่ได้'
      }
    },

    async fetchLocations() {
      try {
        const response = await apiMst.get('/location')
        this.locations = response.data || []
      } catch (error) {
        console.error('Error fetching locations:', error)
      }
    },

    async fetchUsers() {
      try {
        const response = await apiAuth.get('/auth/showdata')
        this.users = response.data || []
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดข้อมูลผู้ใช้ได้'
      }
    },

    async confirm() {
      const fix = this.confirmModelItem
      console.log('Confirm function called with fix:', fix)
      if (!fix) {
        this.errorMessage = 'ไม่พบการซ่อมที่เลือก'
        return
      }

      try {
        const workerId = this.getCurrentUserId()
        const currentTime = new Date().toISOString()
        const fixData = {
          status: { id: 2 },
          workerId: { id: workerId },
          timefixget: currentTime,
        }

        await apiUpdate.put(`/statusUpdate/${fix.id}`, fixData)
        this.showConfirmationModal = false
        this.fixes = []
        this.totalFixes = 0
        this.currentPage = 1
        this.selectedStatusId = 1

        await this.fetchFixes()
      } catch (error) {
        this.showConfirmationModal = false
        this.errorMessage = 'เกิดข้อผิดพลาดในการยืนยัน'
        console.error(error)

        if (error.response && error.response.data) {
          this.errorMessage = error.response.data.message || 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ'
        }
      }
    },

    async fetchSpareList(fixId) {
      try {
        const response = await apiAdmin.get(`/sparelistByFixId/${fixId}`) // URL ตัวอย่าง
        return response.data || []
      } catch (error) {
        console.error('Error fetching spare list:', error)
        return []
      }
    },

    async fetchExpense(fixId) {
      try {
        const response = await apiAdmin.get(`/expensefixList/${fixId}`) // URL ตัวอย่าง
        return response.data || {}
      } catch (error) {
        console.error('Error fetching expense:', error)
        return {}
      }
    },

    async viewDetails(fix) {
      this.selectedFix = { ...fix }
      this.isLoadingViewDetails = true
      this.showDetailsModal = true

      try {
        const [spareList, expense] = await Promise.all([
          this.fetchSpareList(fix.id),
          this.fetchExpense(fix.id),
        ])

        if (spareList && spareList.length > 0) {
          this.spareList = spareList
        } else {
          this.spareList = []
        }

        if (Array.isArray(expense)) {
          this.expense = expense.filter(item => item && item !== '')
        } else if (expense && expense.cost !== undefined) {
          this.expense = [expense]
        } else {
          this.expense = []
        }
      } catch (error) {
        console.error('Error loading data', error)
      } finally {
        this.isLoadingViewDetails = false
      }
    },

    clearSelectedFix() {
      this.selectedFix = null
      this.errorMessage = ''
    },

    editFix(fix) {
      this.selectedFix = { ...fix }
      this.showForm = true
    },

    handleFixSaved() {
      this.fetchFixes()
      this.showForm = false
    },
    getCurrentUserId() {
      return this.$store.state.user ? this.$store.state.user.id : null
    },

    handleShowModal(deviceDetails) {
      this.deviceDetails = deviceDetails.details
      this.deviceWarranty = deviceDetails.warranty
      this.deviceHardware = deviceDetails.hardware
      this.localShowModal = true
    },
    handleCloseModal() {
      this.localShowModal = false
      this.selectedDevice = {}
    },

    handleButtonClick(statusId, buttonType) {
      this.isWaitingApprove = false
      this.selectedStatusId = statusId
      this.activePageButton = buttonType
      this.currentPage = 1
      this.localShowModal = false
      this.fetchFixes()
    },

    async handlePageChangewaitingApprove(page) {
      this.currentPage = page
      await this.fetchFixesheadApprove(this.currentPage)
    },

    headApprovelButtonClick(statusId, buttonType) {
      this.selectedStatusId = statusId
      this.activePageButton = buttonType
      this.currentPage = 1
      this.fetchFixesheadApprove()
    },

    clearSearch() {
      this.categoryId = null
      this.search = {
        order: '',
        username: '',
        startDate: '',
        endDate: '',
        categoryName: '',
      }
    },

  },
}
</script>

<style scoped>
.listdata {
  font-size: x-small;
  margin: 0.5%;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.input-box{
  width: 180px;
  height: 35px;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
}

.fix-table {
  width: 100%; /* ให้ตารางเต็มความกว้าง */
  border-collapse: collapse;
  white-space: nowrap;
}

.fix-table td,
.fix-table th {
  font-size: small;
}

.custom-modal .modal-dialog {
    width: 100vw; /* ทำให้ modal เต็มความกว้าง */
    height: auto; /* ปรับความสูงตามเนื้อหา */
    max-width: none; /* ไม่จำกัดความกว้างสูงสุด */
}

@media (max-width: 768px) {
  .custom-modal .modal-dialog {
    width: 90vw;
  }
}

.custom-modal .modal-content {
  padding: 20px;
  border-radius: 10px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-text {
  margin-top: 10px;
  font-size: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.b-btn {
  margin-right: 10px;
}

.b-spinner {
  color: white;
}

.loading-container {
  text-align: center;
  color: #fff;
}

.clickable-icon {
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px;
}

@media (max-width: 768px) {
  .custom-modal .modal-dialog {
    width: 90vw;
  }
}
.fix-table thead {
    display: none;
  }

  @media (max-width: 768px) {
  .fix-table {
    display: block;
    overflow-x: auto;
  }
}

.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

/* สำหรับมือถือ */
@media (max-width: 360px) {
  .btn-space {
    justify-content: center;
  }

  .btn-space b-button {
    flex: 1 1 100%;
    margin-bottom: 0.5rem;
  }
  .listdata {
    font-size: 0.9rem;
  }

  .search-filters input {
    font-size: 14px;
    width: 100%;
    padding: 8px;
  }

  .search-filters label {
    font-size: 14px;
  }

  .custom-modal .modal-dialog {
        width: 95vw;
  }

  .fix-table td {
        flex-direction: column;
        padding: 8px;
  }
}
.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}
</style>
